import { BaseMaintenanceApi } from './api.base';
import { apiNet } from '@cems-eco/core/src/services/api';

export class CloudMaintenanceApi extends BaseMaintenanceApi {

    async all(): Promise<any> {
        return await apiNet.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await apiNet.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await apiNet.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await apiNet.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async download(fileName: string, id: any): Promise<any> {
        return await apiNet.downloadFile<any>(`${this.BASE_URL}/pdf/${id}`, fileName);
    }

    async destroy(id: any): Promise<any> {
        return await apiNet.delete<any>(`${this.BASE_URL}/${id}`);
    }

    async storeRelation(data: any): Promise<any> {
        return await apiNet.post<any>(`${this.BASE_URL}/relation/store`, data);
    }

    async updateRelation(id: any, data: any): Promise<any> {
        return await apiNet.post<any>(`${this.BASE_URL}/relation/${id}`, data);
    }

    async deleteRelation(id: any): Promise<any> {
        return await apiNet.delete<any>(`${this.BASE_URL}/relation/${id}`);
    }

    async serialNumber(): Promise<any> {
        return await apiNet.get<any>(`${this.BASE_URL}/serial-number`);
    }

    async clientFirst(id: any): Promise<any> {
        return await apiNet.get<any>(`/client/${id}`);
    }

    async siteFirst(id: any): Promise<any> {
        return await apiNet.get<any>(`/site/${id}`);
    }


    async getEquipmentBySite(id: any): Promise<any> {
        const params = {
            search: {
                advanced: {
                    site_id: id
                }
            }
        }
        return await apiNet.get<any>(`/equipment`, params);
    }

    async equipmentFirst(id: any): Promise<any> {
        return await apiNet.get<any>(`/equipment/${id}`);
    }

    async userFirst(id: any): Promise<any> {
        return await apiNet.get<any>(`/user/${id}`);
    }

    getUrl(url): string {
        return apiNet.getUrl(url);
    }

    async getOptions(url, params = {}, keyValue = 'id'): Promise<any[]> {
        let response = await apiNet.get<any>(url, params);
        return (response.data as any[]).map((e) => ({
            label: e.text,
            value: e[keyValue],
        }));
    }
}
